import { supabase } from '../../../src/lib/supabase';

/**
 * Pausa a UC por excesso de saldo (RAT-R11).
 *
 * `saldoCreditosKwh` é o ESTOQUE de créditos da UC — `faturas.saldo_ugs_vigor`,
 * o "SALDO KWH" impresso no bloco SCEE. Não é `saldo_acumulado_kwh`, que apesar
 * do nome é o resultado do MÊS: a regra passou a existência inteira lendo aquele
 * campo e, por isso, nunca pausou uma UC sequer. Ver `coberturaSaldo.ts`.
 *
 * A RPC refaz todas as travas do lado do servidor (consumo confiável, situação
 * elegível, carência pós-destravamento) e levanta exceção quando não se aplica —
 * o chamador trata erro como "não travou".
 */
export async function travarUcExcessoSaldo(ucId: number, saldoCreditosKwh: number): Promise<void> {
  const { error } = await supabase.rpc('travar_uc_excesso_saldo', {
    p_uc_id: ucId,
    p_saldo_creditos_kwh: saldoCreditosKwh,
  });
  if (error) throw error;
}

export async function pausarUcManual(ucId: number): Promise<void> {
  const { error } = await supabase.rpc('pausar_uc_manual', { p_uc_id: ucId });
  if (error) throw error;
}

export async function destravarUc(ucId: number): Promise<void> {
  const { error } = await supabase.rpc('destravar_uc', { p_uc_id: ucId });
  if (error) throw error;
}
